import { render } from "./KartenAuswahl.vue?vue&type=template&id=55a5b425&scoped=true"
import script from "./KartenAuswahl.vue?vue&type=script&lang=js"
export * from "./KartenAuswahl.vue?vue&type=script&lang=js"

import "./KartenAuswahl.vue?vue&type=style&index=0&id=55a5b425&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a5b425"]])

export default __exports__